export default {
    name: 'Nutrition',
    serverName: '/api/v1/normative_calculator/calculation/',
    apiUrl: '/api/v1/normative_calculator/calculation/'
};
